import PropTypes from "prop-types";
import echarts from "echarts";

import Card from "../../components/Cards/Card";
import appearance from "../../components/Charts/Appearance";

import NativeObject from "../../components/NativeObject/NativeObject";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import BarChart from "../../components/Charts/BarChart";

function OnePageMobile({ app, config }) {

  return (
    <div className="app onePage">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            style={{
              width: "100%",
              padding: "12px",
              height: "150px",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "40px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "70%",
                  height: "40px",
                  paddingTop: "2px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* TITULO */}
                <ComboHeader
                  reference={{
                    title: {
                      hard: "Sell Out em R$",
                    },
                  }}
                />
              </div>

              <div
                style={{
                  width: "30%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* INDICADOR PORCENTAGEM */}
                <NativeObject
                  app={app}
                  key="nrZRNX"
                  reference={{ id: "nrZRNX" }}
                />
              </div>
            </div>

            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "25%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* ICONEM */}
                <NativeObject app={app} key="HgTT" reference={{ id: "HgTT" }} />
              </div>

              <div
                style={{
                  width: "85%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="containerKpiValueGrey">
                  {/* VALOR EM CINZA */}
                  <NativeObject
                    className="kpiValueGrey"
                    app={app}
                    key="HXXyMmy"
                    reference={{ id: "HXXyMmy" }}
                  />
                </div>
                <div className="containerKpiValueBold">
                  {/* VALOR PRINCIPAL */}
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="RNWbrV"
                    reference={{ id: "RNWbrV" }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <Card
            style={{
              width: "100%",
              padding: "18px",
              height: "150px",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "40px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "70%",
                  height: "40px",
                  paddingTop: "2px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* TITULO */}
                <ComboHeader
                  reference={{
                    title: {
                      hard: "Cobertura Total",
                    },
                  }}
                />
              </div>

              <div
                style={{
                  width: "30%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* INDICADOR PORCENTAGEM */}
                <NativeObject
                  app={app}
                  key="EhGNd"
                  reference={{ id: "EhGNd" }}
                />
              </div>
            </div>

            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "25%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* ICONEM */}
                <NativeObject
                  app={app}
                  key="CwTNUXN"
                  reference={{ id: "CwTNUXN" }}
                />
              </div>

              <div
                style={{
                  width: "85%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="containerKpiValueGrey">
                  {/* VALOR EM CINZA */}
                  <NativeObject
                    className="kpiValueGrey"
                    app={app}
                    key="ngAFN"
                    reference={{ id: "ngAFN" }}
                  />
                </div>
                <div className="containerKpiValueBold">
                  {/* VALOR PRINCIPAL */}
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="AVmxgGC"
                    reference={{ id: "AVmxgGC" }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <Card
            style={{
              width: "100%",
              padding: "18px",
              height: "150px",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "40px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "90%",
                  height: "40px",
                  paddingTop: "2px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* TITULO */}
                <ComboHeader
                  reference={{
                    title: {
                      hard: "Cobertura Qualificada",
                    },
                  }}
                />
              </div>

              <div
                style={{
                  width: "20%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* INDICADOR PORCENTAGEM */}
                <NativeObject
                  app={app}
                  key="cacVnLr"
                  reference={{ id: "cacVnLr" }}
                />
              </div>
            </div>

            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "25%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* ICONEM */}
                <NativeObject
                  app={app}
                  key="UMQLwpS"
                  reference={{ id: "UMQLwpS" }}
                />
              </div>

              <div
                style={{
                  width: "85%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="containerKpiValueGrey">
                  {/* VALOR EM CINZA */}
                  <NativeObject
                    className="kpiValueGrey"
                    app={app}
                    key="ZsPH"
                    reference={{ id: "ZsPH" }}
                  />
                </div>
                <div className="containerKpiValueBold">
                  {/* VALOR PRINCIPAL */}
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="CBUXP"
                    reference={{ id: "CBUXP" }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <Card
            style={{
              width: "100%",
              padding: "18px",
              height: "150px",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "40px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "70%",
                  height: "40px",
                  paddingTop: "2px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* TITULO */}
                <ComboHeader
                  reference={{
                    title: {
                      hard: "Investimento",
                    },
                  }}
                />
              </div>

              <div
                style={{
                  width: "30%",
                  height: "40px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* INDICADOR PORCENTAGEM */}
                <NativeObject
                  app={app}
                  key="UwjDU"
                  reference={{ id: "UwjDU" }}
                />
              </div>
            </div>

            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "25%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* ICONEM */}
                <NativeObject
                  app={app}
                  key="fFwcyj"
                  reference={{ id: "fFwcyj" }}
                />
              </div>

              <div
                style={{
                  width: "85%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="containerKpiValueGrey">
                  {/* VALOR EM CINZA */}
                  <NativeObject
                    className="kpiValueGrey"
                    app={app}
                    key="WFmLf"
                    reference={{ id: "WFmLf" }}
                  />
                </div>
                <div className="containerKpiValueBold">
                  {/* VALOR PRINCIPAL */}
                  <NativeObject
                    className="kpiValueBold"
                    app={app}
                    key="MhJPM"
                    reference={{ id: "MhJPM" }}
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            style={{
              width: "100%",
              height: "250px",
            }}
          >
            <ComboHeader
              reference={{
                title: {
                  hard: "Sell Out em R$",
                },
              }}
            />
            <BarChart
              app={app}
              reference={{
                id: "Crjg",
                format: "0.00 a",
                axisFormat: "0.00 a",
                tooltipFormat: "0.00 a",
                barWidth: "8%",
              }}
              multiTooltip
              echarts={echarts}
              autoDataZoom
              options={appearance.barchart("barchartOverview")}
            />
          </Card>
          <Card
            style={{
              width: "100%",
              height: "250px",
            }}
          >
            <ComboHeader
              reference={{
                title: {
                  hard: "Cobertura Total",
                },
              }}
            />
            <BarChart
              app={app}
              style={{
                flex: 1,
                height: "98% !important",
                display: "flex",
              }}
              reference={{
                id: "uMZHD",
                format: "0.00 a",
                axisFormat: "0.00 a",
                tooltipFormat: "0.00 a",
                barWidth: "10%",
                zoom: 0,
              }}
              multiTooltip
              echarts={echarts}
              group="evoltuionGroup1"
              options={appearance.barchart("barchartOverview")}
            />
          </Card>

          <Card
            style={{
              width: "100%",
              height: "250px",
            }}
          >
            <ComboHeader
              reference={{
                title: {
                  hard: "Cobertura Qualificada",
                },
              }}
            />
            <BarChart
              app={app}
              style={{
                flex: 1,
                height: "98% !important",
                display: "flex",
              }}
              reference={{
                id: "nbJHn",
                format: "0.00 a",
                axisFormat: "0.00 a",
                tooltipFormat: "0.00 a",
                barWidth: "10%",
                zoom: 0,
              }}
              multiTooltip
              echarts={echarts}
              group="evoltuionGroup2"
              options={appearance.barchart("barchartOverview")}
            />
          </Card>

          <Card
            style={{
              width: "100%",
              height: "300px",
            }}
          >
            <ComboHeader
              reference={{
                title: {
                  hard: "Investimento",
                },
              }}
            />
            <NativeObject app={app} key="ZmdGZ" reference={{ id: "ZmdGZ" }} />
          </Card>
        </div>
      </div>
    </div>
  );
}

OnePageMobile.defaultProps = {
  app: null,
  config: {},
};

OnePageMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OnePageMobile;
